import React from 'react';

const SectionWrapper = ({ 
  children, 
  className = "", 
  containerClassName = "container mx-auto px-4" 
}) => {
  return (
    <section className={className}>
      <div className={containerClassName}>
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
